<template>
  <div id="issue" class="issue fill-height">
    <div v-if="imagePhotos || issue">
      <issue-editor :imagePhotoProp="imagePhotos" :issueProp="issue" :prevRoute="prevRoute"></issue-editor>
    </div>
  </div>
</template>

<script>
import IssueEditor from "@/components/issues/IssueEditor.vue";
import { IssueService } from "@/services";
import Helpers from "@/mixins/helpers";
import { mapGetters } from "vuex";

export default {
  name: "Issue",
  metaInfo: {
    title: "Log-it Editor",
  },
  mixins: [Helpers],
  components: {
    IssueEditor,
  },
  computed: {
    ...mapGetters("issue", ["image", "images"]),
  },
  data: () => ({
    issue: null,
    imagePhotos: null,
    prevRoute: null,
  }),
  methods: {
    async loadIssue(issueId) {
      const r = await IssueService.getIssue(issueId);
      this.issue = r.data;
    },
  },
  mounted() {
    let params = this.$route.params;
    if (params.id) {
      this.loadIssue(params.id);
    } else if (this.images) {
      this.imagePhotos = this.images;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>
